import PageBreadcrumb from "../components/common/PageBreadCrumb";
import PageMeta from "../components/common/PageMeta";
import CartsTable from "../components/tables/CartsTable";

export default function CartsPage() {
    return (
        <>
            <PageMeta
                title="Abandoned Cart Management | Shoplattice Admin Dashboard"
                description="View and manage abandoned shopping carts from registered users"
            />
            <PageBreadcrumb pageTitle="Abandoned Carts" />
            <div className="space-y-6">
                <CartsTable />
            </div>
        </>
    );
}
